import VideoChunk from './VideoChunk';

export default VideoChunk;
